import magnificPopup from 'magnific-Popup';

const video = () => {
  console.log(magnificPopup);
  $(document).ready(function() {
    $('.popup-youtube').magnificPopup({
      type: 'iframe',
    });
  });
}


export default video;